import React, { useEffect, useRef, useState, useImperativeHandle, forwardRef } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import {AutoComplete, Checkbox, Input, Select, Spin} from "antd";

import { transformListForSelect } from "@/utils/list";

import type { MassAdditionCreateForm, MassAdditionFormCreateHandle } from '@/types/MassAddition';

import api from "@/api";

import CardContent from "@/components/card/CardContent";

import './styles/mass-addition-form-create.scss'

interface Props {
    formDefault: any
}

const MassAdditionFormCreate = forwardRef<MassAdditionFormCreateHandle>(({ formDefault }:Props, ref) => {
    const [name, setName] = useState<string>("");
    const [voiceover, setVoiceover] = useState<string>("");
    const [path, setPath] = useState<string>("");
    const [startNumber, setStartNumber] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [directories, setDirectories] = useState<any[]>([]);
    const [voiceovers, setVoiceovers] = useState<any[]>([]);
    const [voiceoverName, setVoiceoverName] = useState<string>('')
    const [voiceoversAll, setVoiceoversAll] = useState<any[]>([])
    const [isActive, setIsActive] = useState<boolean>(true)
    const [has_internal_ads, sethas_internal_ads] = useState<boolean>(false)

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
    };

    const fetchDirectories = async (search: string | null = null) => {
        const responseDirectories = await api.directories.get(search);

        setDirectories(
            transformListForSelect(
                responseDirectories?.data?.data?.directories || [],
                'relative_path',
                'relative_path'
            )
        );
    };

    const fetchAll = async () => {
        try {
            setVoiceovers([]);
            setDirectories([]);
            setIsLoading(true);

            const reponseVoiceovers = await api.voiceovers.get();

            const listVoiceovers = transformListForSelect(reponseVoiceovers?.data?.data?.voiceovers, 'name', 'id');

            setVoiceovers(listVoiceovers);
            setVoiceoversAll(listVoiceovers);

            await fetchDirectories();
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    const getValue = (): MassAdditionCreateForm => {
        return {
            name,
            voiceover,
            path,
            startNumber,
            voiceoverName,
            isActive,
            has_internal_ads
        };
    };

    const updatePath = (val: string) => {
        setPath(val);
    };

    const handleChangeName = (val:string | number) => {
        if (typeof val === 'number') {
            return;
        }

        setVoiceoverName(val)
    }

    const onChangeVoiceover = (val:any) => {
        const findItem = voiceovers.filter((item) => item.id === val)
        if(findItem && findItem[0]) {
            setVoiceoverName(findItem[0]?.name || '')
        } else {
            setVoiceoverName('')
        }
    }

    useImperativeHandle(ref, () => ({
        getValue,
    }));

    useEffect(() => {
        fetchAll();
    }, []);

    useEffect(() => {
        setName(formDefault.name || '');
        setPath(formDefault.path || '');
        setStartNumber(formDefault.startNumber || '');
        setVoiceover(formDefault.voiceover || '');
        setIsActive(formDefault.isActive ?? true);
        sethas_internal_ads(formDefault.has_internal_ads || false)

    }, [formDefault])

    const handleSearchOption = (text:string) => {
        if(!text.trim()) {
            setVoiceovers(voiceoversAll)
        }

        const filtered = voiceoversAll.filter(item =>
            item.name.toLowerCase().includes(text.toLowerCase())
        );

        setVoiceovers(filtered)
    }

    const searchTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    /**
     * Поиск директории идёт на сервере, а не по загруженному списку.
     *
     * Список обрезан лимитом (1000 записей): на проде в хранилище 5573 папки,
     * и всё, что дальше лимита, в браузер не попадало — поиск по локальной
     * копии его не находил (так пропадал «Ouran High School Host Club (2006)/
     * RUS Sound/[Cuba77]»). Сервер отбирает совпадения ДО применения лимита.
     */
    const onSearchDirectory = (text: string) => {
        const term = text.trim();

        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current);
        }

        if (!term) {
            void fetchDirectories();

            return;
        }

        searchTimerRef.current = setTimeout(() => {
            void fetchDirectories(term);
        }, 300);
    }

    const onSelectDirectory = (val) => {
        console.log('onSelectDirectory', val)
    }

    const showInfo = () => {
        console.log('showINfo')
        const x1 = getValue()
        console.log('getValue', x1)
        console.log('has_internal_ads', has_internal_ads)
    }

    return (
        <div className={'mass-addition-form-create'}>
            <CardContent title="Настройки массового добавления">
                {
                    isLoading && <div className={'mass-addition-form-create-loading'}>
                        <Spin indicator={<LoadingOutlined />} />
                    </div>
                }

                {
                    !isLoading && <form onSubmit={(e) => onSubmit(e)} className="mass-addition__form">
                        <div className="form-group">
                            <label className="form-group__label">Шаблон названия эпизода:</label>
                            <Input
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value);
                                }}
                                placeholder="Введите название эпизода"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-group__label" htmlFor="StartNumber">Назначить с номера:</label>
                            <Input
                                id="StartNumber"
                                type="number"
                                value={startNumber}
                                onChange={(e) => {
                                    setStartNumber(Number(e.target.value));
                                }}
                                placeholder="1"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-group__label" htmlFor="Year">Озвучка для всех:</label>
                            <AutoComplete
                                options={voiceovers}
                                value={voiceoverName}
                                onSearch={handleSearchOption}
                                placeholder="Озвучка"
                                className={"app-select"}
                                allowClear
                                onChange={(value) => {
                                    setVoiceover(value);
                                    onChangeVoiceover(value);
                                    handleChangeName(value);
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-group__label">Путь к файлам</label>
                            <AutoComplete
                                options={directories}
                                value={path}
                                onSearch={onSearchDirectory}
                                onSelect={onSelectDirectory}
                                placeholder="Введите путь к файлам"
                                className={"app-select"}
                                allowClear
                                onChange={(val) => {
                                    updatePath(val)
                                }}
                            />
                        </div>

                        <div className="form-group form-group--row">
                            <Checkbox
                                id="Active"
                                className="app-unchecked-checkbox app-checkbox-active"
                                checked={isActive}
                                onChange={(event) => {
                                    setIsActive(event.target.checked)
                                }}
                            />
                            <label className={"form-group-label"} htmlFor="Active">
                                активный
                            </label>
                        </div>

                        <div className="form-group form-group--row">
                            <Checkbox
                                id="has_internal_ads"
                                className="app-unchecked-checkbox app-checkbox-active"
                                checked={has_internal_ads}
                                onChange={(event) => {
                                    sethas_internal_ads(event.target.checked)
                                }}
                            />
                            <label className={"form-group-label"} htmlFor="has_internal_ads">
                                Встроенная реклама
                            </label>
                        </div>
                    </form>
                }
            </CardContent>
        </div>
    );
});

export default MassAdditionFormCreate;